<template>
    <div class="h-full d-flex">
            <div class="h-full-w400px">
                <div class="h-full-h85 p-2">
                    <p class="text-blue font-weight-bold">Publier un nouvel article</p>        
                    <input type="file" class="form-control" id="front_image" aria-describedby="inputGroupFileAddon01">
                    <input type="text" v-model="conseil_title" class="form-control mt-3 mb-3" placeholder="Titre de l'article ...">
                    <textarea id="editorhtml" class="mt-3"></textarea>
                </div>
                <div class="h-full-h15 border-top p-2"> 
                  <button @click="post" class="btn btn-site font-weight-bold btn-sm">Publier maintenant
                    <div v-if="loading" class="spinner-border text-light float-right mt-2" style="height:20px;width:20px" role="status">
                         <span class="sr-only">Loading...</span>
                    </div>
                  </button>
                </div>
            </div>
            <div class="h-full-rw400px border-left p-3">
                <h1 class="text-blue">Liste des conseils publiés</h1>
                <table class="table mt-3 table-bordered table-hover">
                        <thead>
                        <tr>
                            <th>Image</th>
                            <th>Titre</th>
                            <th>Date</th>
                        </tr>
                        </thead>
                        <tbody>
                                <tr v-for="item in conseil" :key="item.id">
                                    <td>
                                       <div style="width:100px;height:100px">
                                          <img :src="'http://localhost:8000/picture/show/'+item.conseil_image" alt="" style="object-fit:cover;width:100%;height:100%">
                                       </div>
                                    </td>
                                     <td>
                                        {{item.conseil_title}}
                                    </td>
                                    <td>
                                        {{item.created_at}}
                                    </td>
                                </tr>
                        </tbody>
                    </table>
            </div>
    </div>
</template>

<script>
import $ from 'jquery';
import backendService from '../../../backend.service';
// import backendService from '../../../backend.service'
export default {
    data(){
      return {
          conseil_title : null,
          coneil_content : null,
          loading : false,
          conseil : []
      }
    },
    mounted(){
      $('#editorhtml').summernote({
        placeholder: 'Saisissez ...',
        tabsize: 2,
        height: 100,
        toolbar: [
          ['style', ['style']],
          ['font', ['fontname','bold', 'underline', 'clear','strikethrough', 'superscript', 'subscript']],
          ['color', ['color']],
          ['fontsize', ['fontsize']],
          ['para', ['ul', 'ol', 'paragraph']],
          ['table', ['table']],
          ['insert', ['link', 'picture','video','hr']],
          ['view', ['fullscreen','codeview']]
        ]
      });

      backendService.conseil_public_get().then((response)=>{
                  this.conseil = response.data.data;
      }).catch(()=>{})
    },
     methods  : {
        post(){
              this.loading = true;
              let me = this;
              var fd = new FormData();
              var files = $('#front_image')[0].files[0];
              fd.append('conseil_title',me.conseil_title);
              fd.append('conseil_content',$('#editorhtml').summernote('code'));
              fd.append('conseil_file',files);
              $.ajax({
                  url: 'https://apidistrico.districom-ci.net/public/oauth/api/interface/conseil/create',
                  type: 'post',
                  data: fd,
                  contentType: false,
                  processData: false,
                  headers:{
                      "Authorization" : "Bearer "+ JSON.parse(localStorage.getItem('districosite__api__Oauth')).token,
                  },
                  success: function(response){
                      me.loading = false;
                      if(response.status == 200){
                        alert('article publié avec succès !');
                        me.conseil = response.data;
                      }
                  },
              });
        }
    }
}
</script>

<style>

</style>